import { OrderedSet } from 'immutable';

import { ReduxState } from 'app/redux/types';

export const favoriteTournamentIds = (state: ReduxState): OrderedSet<number> => {
  return state.favorites.tournamentIds;
};

export const favoriteMatchIds = (state: ReduxState): OrderedSet<number> => {
  return state.favorites.matchIds;
};

export const isFavoriteTournament = (state: ReduxState, tournamentId: number): boolean => {
  return favoriteTournamentIds(state).has(tournamentId);
};

export const isFavoriteMatch = (state: ReduxState, matchId: number): boolean => {
  return favoriteMatchIds(state).has(matchId);
};
